var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('v-navigation-drawer',{staticClass:"chats-panel-drawer",attrs:{"app":"","right":"","permanent":"","width":"300","color":"surface"}},[_c('students-chat-panel-body')],1):_c('div',{staticClass:"chats-panel--mobile"},[_c('students-chat-panel-body')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }